// extracted by mini-css-extract-plugin
export default {"TimerContainer":"DigitalTimer_TimerContainer__93bFS","separatorContainer":"DigitalTimer_separatorContainer__VnskA","separator":"DigitalTimer_separator__iRt5v"};